import { WorkerWithdrawalPreviewResponse } from '@thera-hr/api-sdk/api/resources/api/resources/thera/resources/bank';
import GenericModal from './GenericModal';
import useIntl from 'hooks/useIntl';

export default function ExchangeDetails({
  open,
  onClose,
  convertedAmount,
  balanceCurrency,
  withdrawalCurrency,
}: {
  open: boolean;
  onClose: () => void;
  convertedAmount: WorkerWithdrawalPreviewResponse;
  balanceCurrency: string;
  withdrawalCurrency: string;
}) {
  const { formatCurrencyToLocale } = useIntl();
  const exchangeFrom = convertedAmount?.exchangeFrom + convertedAmount?.variableFee;
  const _exchangeRate = convertedAmount?.exchangeTo / exchangeFrom;
  const exchangeRate = _exchangeRate.toFixed(6); // rounding up the value

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      showHeaderBorder={false}
      width="min-w-min w-[500px]"
      title="Exchange Details"
      titleCenter
      subTitle="To help you get a better exchange rate, we recommend withdrawing a larger amount when possible."
    >
      <div className="mt-1 flex items-center justify-between rounded-md bg-neutral-50 p-4 text-sm">
        <span className="flex text-neutral-500">Exchange Rate</span>
        <p className="text-sm font-medium text-neutral-800">
          1 {balanceCurrency} = {exchangeRate} {withdrawalCurrency}
        </p>
      </div>

      <div className="mt-2 flex items-center justify-between rounded-md bg-neutral-50 p-4 text-sm">
        <span className="text-neutral-500">Exchange From</span>
        <span className="font-medium text-neutral-800">
          {formatCurrencyToLocale(exchangeFrom, convertedAmount?.feeCurrency)}
        </span>
      </div>

      <div className="mt-2 flex items-center justify-between rounded-md bg-neutral-50 p-4 text-sm">
        <span className="flex text-neutral-500">Exchange To</span>
        <div className="text-right">
          <p className="text-sm font-medium text-neutral-800">
            {formatCurrencyToLocale(convertedAmount?.exchangeTo, withdrawalCurrency)}
          </p>
        </div>
      </div>
    </GenericModal>
  );
}
